export default "__VITE_ASSET__DTVhb$7m__"